module.exports = " <div class=vc-item-form :class=\"{'focus-state': focus, 'not-empty-state': noEmpty}\"> <div class=vc-item-form-icon v-if=icon> <icon :value=icon></icon> </div> <div class=vc-item-form-content> <div class=label v-if=label>{{label}}</div> <slot></slot> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/forms/itemForm.vue
 ** module id = 440
 ** module chunks = 1
 **/